import { Moon } from 'lunarphase-js';

export default function moonPhase() {
  let icon: number;
  let title: string;

  const age = Math.round(Moon.lunarAge());
  const symbol = Moon.lunarPhaseEmoji();

  if (age < 7) {
    icon = 1;
    title = 'new';
  } else if (age >= 7 && age < 14) {
    icon = 2;
    title = 'waxing';
  } else if (age >= 14 && age < 22) {
    icon = 3;
    title = 'full';
  } else if (age >= 22 && age < 29) {
    icon = 4;
    title = 'waning';
  } else {
    icon = 1;
    title = 'new';
  }

  return { icon, title, symbol };
}
